export const TEXT_RRHH = {
  es_ES: new Map([
    ['titleTareasPendientes', 'TAREAS PENDIENTES POR MES'],
    ['titleTareasRealizadas', 'TAREAS REALIZADAS POR MES'],
    ['titleTareasRealizadasAnyo', 'TAREAS REALIZADAS POR AÑO'],
    ['legendTareasRealizadasAnyo', 'Tareas realizadas por año'],
    ['titleTareasPendientesAnyo', 'Tareas pendientes por año'],
    ['titleBacklogMensual', 'CARGA ADMINISTRATIVA'],
    ['reset', 'Restablecer'],
    ['download', 'Descargar'],
    ['months', 'Meses'],
    ['tasks', 'Tareas'],
  ]),
  ca_ES: new Map([
    ['titleTareasPendientes', 'Tasques pendents per mes'],
    ['titleTareasRealizadas', 'Tasques realitzades per mes'],
    ['titleTareasRealizadasAnyo', 'Tasques realitzades per any'],
    ['titleTareasPendientesAnyo', 'Tasques pendents per any'],
    ['titleBacklogMensual', 'Càrrega administrativa'],
    ['reset', 'Restablir'],
    ['download', 'Desar'],
    ['months', 'Mesos'],
    ['tasks', 'Tasques'],
  ]),
};
